interface LocalRequestsConfiguration {
  environment?: string;
  enabled?: string;
  hostname?: string;
}

export const getMerchantRequestsContext = (
  configuration: LocalRequestsConfiguration = {
    environment: process.env.NODE_ENV,
    enabled: process.env.REACT_APP_LOCAL_MERCHANT_REQUESTS,
    hostname:
      typeof window === 'undefined' ? undefined : window.location.hostname,
  },
): { uri: string } | undefined => {
  if (
    configuration.environment === 'development' &&
    configuration.enabled === 'true' &&
    ['localhost', '127.0.0.1'].includes(configuration.hostname || '')
  ) {
    // Nhost's existing Apollo auth link continues supplying the bearer header.
    return { uri: '/__local/merchant-requests' };
  }
  return undefined;
};
